const baseURL = process.env.REACT_APP_BASE_URL
const authenticatedUser = 'authenticatedUser'
const userDetails = 'userDetails'
const naira = '&#8358;'

export {
    baseURL,
    authenticatedUser,
    userDetails,
    naira
}